import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingJpegToTiffConfig } from '@/data/landingConfig/landingJpegToTiffConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_JpegToTiff } from './schemaObject';

interface Props {}
const JpegToTiffConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_JpegToTiff} />
			<LandingTemplate
				data={landingJpegToTiffConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default JpegToTiffConverter;
